module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("BAD SANTA")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("He knows when you are sleeping, he knows when you’re awake, he knows when is the best time to thieve from department stores so answer these questions for goodness’ sake … Yes, folks, it’s everyone’s favourite anti-Christmas movie. Billy Bob Thornton is brilliantly cast as the drunken, potty-mouthed safecracker under not-so-deep cover as a department store Santa. With a bunch of laughs, some splendid action scenes, a fair chunk of tugs-at-the-heart-strings and the unlikely-but-inevitable final redemption, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bad Santa")]), _vm._v(" is very much a modern Chrimbo movie. If you’re sick of schmaltziness and snow-covered scenes of lovey-dovey Xmas films, this is an ideal way to re-set the heart-clock. But how well do you know the movie? Let’s dive right in …")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('h3', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("20 Questions")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("1.")]), _vm._v(" What is the scheme that Willie T. Soke and Marcus Skidmore put into play every year?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("2.")]), _vm._v(" And who is the third member of the team?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("3.")]), _vm._v(" What is the name of the manager of the mall in Saguaro Square, who Willie’s foul mouth offends?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("4.")]), _vm._v(" What attracts Willie to Sue at the bar?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("5.")]), _vm._v(" What does Thurman Merman say his dad Roger was doing?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("6.")]), _vm._v(" But where is Roger really?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("7.")]), _vm._v(" Why does Willie end up moving into Thurman’s house?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("8.")]), _vm._v(" What gift did Thurman request from Santa, and what does he change it to?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("9.")]), _vm._v(" And what have the bullies done to him?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("10.")]), _vm._v(" What does Willie give Thurman, and why?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("11.")]), _vm._v(" What present does Thurman give Willie?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("12.")]), _vm._v(" What does Gin demand from Willie and Marcus?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("13.")]), _vm._v(" But what drastic step do Marcus and Lois take?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("14.")]), _vm._v(" How does Thurman respond when Willie tells him that he is not actually Santa?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("15.")]), _vm._v(" What does Marcus reveal that he was planning to do to Willie?")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("16.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("What does Willie grab as he makes his escape?")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("17.")]), _vm._v(" But what happens just before he can reach Thurman's front door?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("18.")]), _vm._v(" Why is Willie found innocent?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("19.")]), _vm._v(" And what will Willie’s new job be?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("20.")]), _vm._v(" What is Sue’s new role at the end?")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Answers on ")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter41#page_266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 266")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d54e777","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Chapter02.vue
// module id = 75
// module chunks = 0